import React from 'react';

import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages';
import AtlassianIntelligenceIcon from '@atlaskit/icon/core/atlassian-intelligence';
import sharedMessages from '@atlassian/generative-ai-modal/utils/messages';

import {
	createInsertAtCurrentPosition,
	createInsertBelow,
	createReplace,
} from '../../actions/create-actions';
import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
import type { EditorPluginAIConfigItem } from '../../config-items';

export const freeGenerate: EditorPluginAIConfigItem = {
	key: CONFIG_ITEM_KEYS.FREE_GENERATE,
	title: sharedMessages.aiButtonTitle,
	description: sharedMessages.aiUniversalLongCallToAction,
	promptHint: aiConfigItemMessages.freeGeneratePromptHint,
	icon: () => <AtlassianIntelligenceIcon label="" spacing="spacious" />,
	doNotHighlightDocWhenSelectionIsEmpty: true,
	notReplaceDocOnEmptySelection: true,
	agentId: 'editor_agent',
	canTogglePageKnowledge: true,
	quickInsertPriority: Number.NEGATIVE_INFINITY,
	intentSchemaId: 'custom_free_generate_intent_schema.json',
	featureId: 'free_generate',
	actions: {
		empty: [createInsertAtCurrentPosition({ appearance: 'primary' })],
		selection: [
			createInsertBelow({ appearance: 'secondary' }),
			createReplace({ appearance: 'primary' }),
		],
	},
	getBackendModel: () => {
		return 'assistance-service';
	},
	withContextMutation: (configItem, { latestPromptResponse }) => {
		return latestPromptResponse
			? {
					...configItem,
					intentSchemaId: 'custom_with_interrogation_intent_schema.json',
					featureId: 'interrogation',
				}
			: configItem;
	},
};
